import React, { useState, useEffect } from "react";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/Portfolio")({
  component: Portfolio,
});

const projects = [
  {
    id: "CASE_STUDY_01",
    code: "AYM-MODERN",
    title: "ERP Order Emails Automation",
    description: "Architected a full-scale migration of a legacy Windows Forms application into a modern .NET Core web solution. Features real-time ticketing and Azure AD integration.",
    tech: ["C#", ".NET 7", "SQL_SERVER", "AZURE_AD", "IIS_HOSTING", "WORKER_SERVICE"],
    image: "https://images.unsplash.com/photo-1480944657103-7fed22359e1d?q=80&w=1932&auto=format&fit=crop&q=80&w=2000",
    impact: "Modernized workflow automation & internal IT reliability",
    link: "/WinFormModern" 
  },
  {
    id: "CASE_STUDY_02",
    code: "TKTN-REST",
    title: "SAAS_SCALABILITY_ENGINE",
    description: "Developed and optimized RESTful APIs for a high-traffic SaaS platform. Implemented multi-threaded operations and Stripe API integration for PCI-compliant payments.",
    tech: ["ASP.NET", "REACT", "STRIPE", "REST"],
    image: "https://images.unsplash.com/photo-1619243142206-381c5aeda31c?q=80&w=2070&auto=format&fit=crop&q=80&w=1000",
    impact: "Support for 100s of concurrent users",
    link: "/SaasScalability"
  },
  {
    id: "CASE_STUDY_03",
    code: "AYM-AUTO",
    title: "Multi-Source E-commerce Aggregator",
    description: "Automating the aggregation of YouTube metadata and SKU manifests into normalized e-commerce templates.",
    tech: ["PYTHON", "EXCEL", "AUTOMATION", "DATA_AGGREGATION"],
    image: "https://images.unsplash.com/photo-1675271591211-126ad94e495d?auto=format&fit=crop&q=80&w=1000",
    impact: "Reduced deployment risk & manual processing time",
    link: "/InfraAutomation"
  },
  // {
  //   id: "CASE_STUDY_04",
  //   code: "SEC-HARDEN",
  //   title: "ZERO_TRUST_AUTH_GATEWAY",
  //   description: "Implemented centralized authentication using Azure AD and MFA. Established secure VPC networking and security groups to harden internal infrastructure.",
  //   tech: ["AZURE AD", "VPC", "SECURITY_GROUPS"],
  //   image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=1000",
  //   impact: "Secured internal service access & DNS/Network integrity",
  //   link: "/ZeroTrustSecurity"
  // }
];

// Project Item Component with grey hover and relative navigation
function ProjectItem({ p }: { p: typeof projects[0] }) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleRoute = () => {
    if (p.link.startsWith("/")) {
      navigate({ to: p.link });
    } else if (p.link !== "#") {
      window.open(p.link, "_blank");
    }
  };

  return (
    <section
      style={{
        ...rowStyle,
        backgroundColor: isHovered ? "#161616" : "transparent",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleRoute}
    >
      <div style={metaColumn}>
        <span style={idStyle}>REF_{p.id}</span>
        <span style={codeStyle}>{p.code}</span>
      </div>

      <div style={contentColumn}>
        <h2 style={projectTitleStyle}>{p.title}</h2>
        <p style={descStyle}>{p.description}</p>
        <div style={tagRow}>
          {p.tech.map((t) => (
            <span key={t} style={tagStyle}>{t}</span>
          ))}
        </div>
        <div style={impactBox}>
          <span style={impactLabel}>CORE_IMPACT:</span> {p.impact}
        </div>
      </div>

      <div style={imageColumn}>
        <div style={imageFrame}>
          <img src={p.image} alt={p.title} style={imgStyle} />
        </div>
      </div>
    </section>
  );
}

export function Portfolio() {
 useEffect(() => {
    document.title = "root@❤️:/Portfolio";
  }, []);

  
  return (
    <div style={containerStyle}>
      {/* Navigation matching Home page style */}
      <nav style={navStyle}>
        <div style={navBrand}>
          <div style={avatarStyle}>JF</div>
          <span style={{ fontWeight: "bold", letterSpacing: "1px" }}>JOSH_FLORES</span>
        </div>
        <div style={navLinks}>
          <Link to="/Home" style={navLink}>HOME</Link>
          <Link to="/Portfolio" style={{ ...navLink, color: "#fff" }}>PORTFOLIO</Link>
          {/*<Link to="/Blog" style={navLink}>BLOG</Link>*/}
          <a href="mailto:joshflor07@gmail.com" style={navLink}>CONTACT</a>
        </div>
      </nav>

      <main style={mainContent}>
        {projects.map((p) => (
          <ProjectItem key={p.id} p={p} />
        ))}
      </main>
    </div>
  );
}

/* STYLING */

const containerStyle: React.CSSProperties = {
  backgroundColor: "#0a0a0a",
  color: "#e0e0e0",
  minHeight: "100vh",
  padding: "120px 24px 60px 24px",
  fontFamily: "monospace",
};

const navStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  height: "70px",
  backgroundColor: "rgba(10, 10, 10, 0.8)",
  backdropFilter: "blur(12px)",
  borderBottom: "1px solid #222",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0 40px",
  zIndex: 1000,
};

const navBrand: React.CSSProperties = { display: "flex", alignItems: "center", gap: "12px" };

const navLinks: React.CSSProperties = { display: "flex", gap: "30px" };

const navLink: React.CSSProperties = {
  textDecoration: "none",
  color: "#666",
  fontSize: "12px",
  fontWeight: "bold",
};

const avatarStyle: React.CSSProperties = {
  width: "32px",
  height: "32px",
  backgroundColor: "#1a1a1a",
  border: "1px solid #333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "12px",
  fontWeight: "bold",
  borderRadius: "8px",
};

const mainContent: React.CSSProperties = {
  maxWidth: "1000px",
  margin: "0 auto",
};

const rowStyle: React.CSSProperties = {
  display: "flex",
  padding: "40px",
  gap: "40px",
  borderRadius: "20px",
  transition: "all 0.2s ease",
  cursor: "pointer",
  marginBottom: "10px",
  border: "1px solid transparent",
};

const metaColumn: React.CSSProperties = { width: "80px", display: "flex", flexDirection: "column", gap: "5px" };
const idStyle: React.CSSProperties = { fontSize: "10px", color: "#444" };
const codeStyle: React.CSSProperties = { fontSize: "12px", color: "#666", fontWeight: "bold" };

const contentColumn: React.CSSProperties = { flex: 2 };
const projectTitleStyle: React.CSSProperties = { fontSize: "20px", margin: "0 0 15px 0", color: "#fff", fontWeight: "bold" };
const descStyle: React.CSSProperties = { fontSize: "14px", color: "#888", lineHeight: "1.6", marginBottom: "20px" };

const tagRow: React.CSSProperties = { display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap" };
const tagStyle: React.CSSProperties = { fontSize: "10px", backgroundColor: "#1a1a1a", border: "1px solid #333", padding: "4px 10px", color: "#aaa", borderRadius: "6px" };

const impactBox: React.CSSProperties = { fontSize: "11px", color: "#666", borderLeft: "2px solid #333", paddingLeft: "15px" };
const impactLabel: React.CSSProperties = { color: "#888", marginRight: "5px", fontWeight: "bold" };

const imageColumn: React.CSSProperties = { flex: 1, display: "flex", alignItems: "center" };
const imageFrame: React.CSSProperties = { borderRadius: "12px", overflow: "hidden", border: "1px solid #222", width: "100%" };
const imgStyle: React.CSSProperties = { width: "100%", height: "140px", objectFit: "cover", opacity: 0.5 };

export default Portfolio;